import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import useConfig from '../../hooks/useConfig';

var Image = function Image(_ref) {
  var pid = _ref.pid,
      id = _ref.id,
      config = _ref.config,
      className = _ref.className,
      onClick = _ref.onClick,
      render = _ref.render;

  var clickHandler = function clickHandler() {
    onClick === null || onClick === void 0 ? void 0 : onClick({
      render: render,
      pid: pid,
      componentId: id
    });
  };

  var _useConfig = useConfig(),
      createNamespace = _useConfig.createNamespace,
      prefixCls = _useConfig.prefixCls;

  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace('image', prefixCls), className);
  return _jsx("img", {
    src: config === null || config === void 0 ? void 0 : config.src,
    alt: config === null || config === void 0 ? void 0 : config.alt,
    className: classes,
    onClick: clickHandler,
    "data-componentid": id,
    "data-pid": pid
  });
};

Image.displayName = 'Image';
export default Image;